// extracted by mini-css-extract-plugin
export default {"status-chip":"launchDetail_status-chip__Qa0RX","subtitle-stack":"launchDetail_subtitle-stack__bV3O1","subtitle-text":"launchDetail_subtitle-text__l9Lal"};